
import { createAction } from "@reduxjs/toolkit"
export const setDomain = createAction("common/setDomain")